import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TabPanel from './TabPanel.js'
import EditCard from '../EditCard.js'
import GaayPage from '../../Pages/Gaay.js'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        minHeight: '90vh',
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        width: '200px'
    }
}));

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function Gaay() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Tabs
                orientation="vertical"
                indicatorColor="primary"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                className={classes.tabs}
            >
                <Tab label="Preview" {...a11yProps(0)} />
                <Tab label="Header" {...a11yProps(1)} />
                <Tab label="Carousel" {...a11yProps(2)} />
                <Tab label="Main Video" {...a11yProps(3)} />
                <Tab label="Activities" {...a11yProps(4)} />
            </Tabs>
            <TabPanel value={value} index={0} preview>
                <GaayPage />
            </TabPanel>
            <TabPanel value={value} index={1} preview={false}>
                <EditCard title="HEADER" textKey="gau_header" imageKeys={["/images/3G/gau-bg.jpg", "/images/3G/gau-bg-m.jpg"]} heading subheading/>
            </TabPanel>
            <TabPanel value={value} index={2} preview={false}>
                <EditCard title="CAROUSEL 1" textKey="gau_c1_p1" imageKeys={["/images/3G/canva4.jpg"]} heading subheading titleS="Paragraph 1"/>
                <EditCard title="" textKey="gau_c1_p2" imageKeys={["/images/3G/canva5.jpg"]} subheading titleS="Paragraph 2"/>
                <EditCard title="" textKey="gau_c1_p3" imageKeys={["/images/3G/canva1.jpg"]} subheading titleS="Paragraph 3"/>
            </TabPanel>
            <TabPanel value={value} index={3} preview={false}>
                <EditCard title="YOUTUBE INSPIRING VIDEO" textKey="gau_main_vdo" heading subheading paragraph titleP="Youtube Video Link"/>
            </TabPanel>
            <TabPanel value={value} index={4} preview={false}>
                <EditCard title="ACTIVITIES" textKey="gau_act" heading subheading/>
                <EditCard title="ACTIVITY 1" textKey="gau_act_1" heading subheading paragraph titleP="Youtube Link"/>
                <EditCard title="ACTIVITY 2" textKey="gau_act_2" heading subheading paragraph titleP="Youtube Link"/>
                <EditCard title="ACTIVITY 3" textKey="gau_act_3" heading subheading paragraph titleP="Youtube Link"/>
            </TabPanel>
        </div>
    );
}
